import DealRows from "@/components/DealRows";

const FEST_DEFS = [
  { key: "trending", title: "Trending Items", sub: "What businesses are stocking up on" },
  { key: "deals", title: "Deals For You", sub: "Biggest savings right now" },
  { key: "essentials", title: "Festive Essentials", sub: "Top-rated picks across every category" },
];

const festHeader = (
  <div className="flex items-center gap-4">
    <h2 className="font-display text-3xl tracking-[0.05em] text-1 sm:text-4xl" data-testid="fest-title">
      STOCK UP FEST
    </h2>
    <span className="hidden h-px flex-1 bg-gradient-to-r from-[#F59E0B]/60 to-transparent sm:block" />
    <span className="rounded-full border border-[#F59E0B]/50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.22em] text-[#F59E0B]">
      Diwali Sale Event
    </span>
  </div>
);

/**
 * FestDealRows — STOCK UP FEST sale rows on the homepage while a festival
 * theme is active. Amber-orange gradient panels, "STOCK UP FEST" tile tag.
 */
export default function FestDealRows() {
  return (
    <DealRows
      defs={FEST_DEFS}
      tag={(p) => (p.discount_pct > 0 ? `Save ${p.discount_pct}%` : "Festive Price")}
      panelClass="fest-row-panel"
      arrowTextClass="text-orange-600"
      testidPrefix="fest-row"
      header={festHeader}
      sectionId="stock-up-fest"
    />
  );
}
